import HandleExpandCollapseSection from './HandleExpandCollapseSection';

export default HandleExpandCollapseSection;
